.liquidationAttributes {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 1.5rem 0;
}
